import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ParentPain } from './components/ParentPain';
import { Reframe } from './components/Reframe';
import { Transformation } from './components/Transformation';
import { ToolkitIntro } from './components/ToolkitIntro';
import { LookInside } from './components/LookInside';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ParentFeedback } from './components/ParentFeedback';
import { OfferStack } from './components/OfferStack';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
type AppProps = {
  /** Turn on once real interior page screenshots are added to previewSlots in data/content.ts. */
  showLookInside?: boolean;
};
export function App({
  showLookInside = false
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3ij66mgga9xb1">
      <noscript data-id="element-1" data-mp="3mlavz2zp87rv">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3mkre1ma1tjdu" />
      </noscript>
      <SiteHeader data-id="element-3" data-mp="4n725ibkvc5" />
      <main data-id="element-4" data-mp="56qjqnmbrsa">
        <Hero data-id="element-5" data-mp="7svdij4jt6t" />
        <ParentPain data-id="element-6" data-mp="2zld1d7i6tbah" />
        <Reframe data-id="element-7" data-mp="2zlv6yuqqp1v2" />
        <Transformation data-id="element-8" data-mp="2zmeoiach9o8k" />
        <ToolkitIntro data-id="element-9" data-mp="2zn69yscd25l4" />
        {showLookInside && <LookInside data-id="element-10" data-mp="33m5cy7ej7s9x" />}
        <WhatsIncluded data-id="element-11" data-mp="33nq9g2keplaf" />
        <ParentFeedback data-id="element-12" data-mp="33mykhalbelt4" />
        <OfferStack data-id="element-13" data-mp="38lrp0dimj2h5" />
        <Faq data-id="element-14" data-mp="38l8gfnev5qfs" />
        <FinalClose data-id="element-15" data-mp="38kqcs5pvg9xu" />
      </main>
      <Footer data-id="element-16" data-mp="38kgmeh0x00rm" />
    </div>;
}